<script>
    import { store } from "../../store.js";
</script>

<svg
    aria-labelledby={$$props["data-unique_id"] + "_title"}
    aria-describedby={$$props["data-unique_id"] + "_desc"}
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <title id={$$props["data-unique_id"] + "_title"}>List</title>
    <desc id={$$props["data-unique_id"] + "_desc"}>List</desc>
    <g
        class="listIcon {$store.options[$$props.id].filtres.mode === 'list'
            ? 'active'
            : ''}"
    >
        <rect y="20.5" width="7" height="7" rx="1" />
        <rect y="10.5" width="7" height="7" rx="1" />
        <rect y="0.5" width="7" height="7" rx="1" />
        <line x1="9" y1="4" x2="27" y2="4" />
        <line x1="9" y1="14" x2="27" y2="14" />
        <line x1="9" y1="24" x2="27" y2="24" />
    </g>
</svg>

<style>
    .listIcon * {
        fill: #888;
        stroke: #888;
    }
    .listIcon.active * {
        fill: #3a7c3c;
        stroke: #3a7c3c;
    }
</style>
